import apiRequest from './apiRequest';

const getActiveRewardCount = async (): Promise<string> => {
  const res = await apiRequest('getActiveRewardCount');

  if (res.error) {
    return '0';
  } else {
    return res.data;
  }
};

export default getActiveRewardCount;
